// A reference period only; the server enforces the floor against the separately
// recorded final UTC deadline. No taxpayer timezone or exception is inferred.
export function retentionReference(
  rule: string,
  yearEnd: string,
  filed: string,
  due: string,
): string | null {
  const valid = (value: string) =>
    /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    !Number.isNaN(Date.parse(`${value}T00:00:00Z`)) &&
    new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value &&
    Number(value.slice(0, 4)) >= 1 &&
    Number(value.slice(0, 4)) <= 9993;
  if (rule === "ro_accounting" && valid(yearEnd))
    return `${Number(yearEnd.slice(0, 4)) + 6}`.padStart(4, "0") + "-07-01";
  if (
    !["us_ordinary", "us_omission"].includes(rule) ||
    !valid(filed) ||
    !valid(due) ||
    filed > new Date().toISOString().slice(0, 10)
  )
    return null;
  const anchor = filed > due ? filed : due;
  const year = Number(anchor.slice(0, 4)) + (rule === "us_ordinary" ? 3 : 6);
  const month = Number(anchor.slice(5, 7));
  const day = Math.min(
    Number(anchor.slice(8, 10)),
    new Date(Date.UTC(year, month, 0)).getUTCDate(),
  );
  return (
    `${year}`.padStart(4, "0") +
    `-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
  );
}
